module.exports = __webpack_public_path__ + "static/img/beian-icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beian-icon.png
// module id = X5CD
// module chunks = 3